<template>
  <div
    v-if="showContent"
    style="
      background: #ededed;
      display: grid;
      place-items: center;
      height: 100vh;
    "
  >
    <form class="login-form" @submit.prevent="loginFunc">
      <p style="color: #1d1d1d; font-size: 24px; font-weight: 600">Вхід</p>

      <p class="login-form-field-name" style="margin-top: 15px">Логін</p>
      <v-text-field
        outlined
        dense
        placeholder="Введіть логін"
        v-model="user.email"
        :error-messages="emailErrors"
      />

      <p class="login-form-field-name">Пароль</p>
      <v-text-field
        outlined
        dense
        placeholder="Введіть пароль"
        v-model="user.password"
        :error-messages="passwordErrors"
        :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
        :type="showPassword ? 'text' : 'password'"
        @click:append="showPassword = !showPassword"
      />

      <v-row
        v-if="errorMessage"
        align="center"
        no-gutters
        style="margin: 0px 0px 20px 0px"
      >
        <span class="error-message">{{ errorMessage }}</span>
      </v-row>

      <admin-submit-button type="submit" width="100%" :loading="isLoadingBtn"
        >Увійти</admin-submit-button
      >
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
import { required } from "vuelidate/lib/validators";
import adminSubmitButton from "../../UI/Btns/adminSubmitButton.vue";
import authService from "@/requests/Admin/authService";
import { mapActions } from "vuex/dist/vuex.common.js";

Vue.use(Vuelidate);

export default {
  components: { adminSubmitButton },
  data() {
    return {
      showPassword: false,
      showContent: true,
      isLoadingBtn: false,
      user: {
        email: "",
        password: "",
      },
      errorMessage: "",
    };
  },
  validations: {
    user: {
      email: {
        required, //email
      },
      password: { required },
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.user.email.$dirty) return errors;
      if (!this.$v.user.email.required)
        errors.push("Поле email не може бути порожнім.");
      // if (!this.$v.user.email.email)
      //   errors.push("Поле email введено не коректно.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.user.password.$dirty) return errors;
      if (!this.$v.user.password.required)
        errors.push("Поле пароль не може бути порожнім.");
      return errors;
    },
  },
  methods: {
    ...mapActions(["updateInfoLogged"]),
    async loginFunc() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isLoadingBtn = true;
        const form = new FormData();
        form.append("login", this.user.email);
        form.append("password", this.user.password);
        await authService
          .login(form)
          .then((res) => {
            this.updateInfoLogged({
              ...res,
              login: this.user.email,
            });
            this.$router.push('/admin')
          })
          .catch(() => {
            this.isLoadingBtn = false;
            this.errorMessage = "* Невірний логін або пароль";
          });
      }
    },
  },
};
</script>

<style scoped>
.login-form {
  font-family: Rubik;
  padding: 30px;
  border-radius: 10px;
  border: 1px solid #f0f0f0;
  background: #fafafa;
  width: 463px;
}
.login-form-field-name {
  color: #1d1d1d;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}
.error-message {
  color: red;
  font-size: 12px;
}
</style>
